import { useVisualizer } from '../context/AppContext.jsx';
import VisualizationControls from './sections/VisualizationControls.jsx';

export default function CenterPanel() {
  const { visualizer } = useVisualizer();

  return (
    <main className="flex-1 flex flex-col bg-bg-secondary rounded-xl overflow-hidden">
      <div className="p-4 border-b border-border relative">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">3D Visualization</h2>
          <div className="relative">
            <VisualizationControls />
          </div>
        </div>
      </div>
      <div
        id="viewer"
        className="flex-1 relative"
      >
        {!visualizer && (
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-text-secondary">Load a .urp file to visualize waypoints</p>
          </div>
        )}
      </div>
    </main>
  );
}

